<template>
  <v-content class="pa-12">
    <!-- Nevigater -->
    <v-layout mb-12>
      <v-flex
        shrink
        d-flex
        justify-start
        align-center
        class="nevigater-link"
        @click="$router.push('/all-news')"
      >
        <span>ข่าวสารทั้งหมด</span>
      </v-flex>
      <v-flex shrink d-flex justify-start align-center>
        <v-icon color="#3E7662">arrow_right</v-icon>
      </v-flex>
      <v-flex
        shrink
        d-flex
        justify-start
        align-center
        style="color: #3E7662;font-weight: bold;font-size: 24px;"
      >
        <span>สร้างข่าวสาร</span>
      </v-flex>
    </v-layout>

    <!-- Form -->
    <v-card tile>
      <v-divider
        style="background-color: #3E7662;border-width: 30px"
      ></v-divider>
      <v-divider
        style="background-color: #544A44;border-width: 2px"
      ></v-divider>
      <v-layout pl-6 py-2 style="background-color: #FBF6F3">
        <v-flex style="color: #000000;text-align: left;font-weight: bold">
          <span>สร้างข่าวสาร</span>
        </v-flex>
      </v-layout>
      <v-layout px-12 py-6>
        <v-flex>
          <!-- blog 1 -->
          <v-layout>
            <v-flex style="text-align: left;font-weight: bold">
              <span>หัวข้อข่าวสาร</span>
            </v-flex>
          </v-layout>
          <v-layout mt-2>
            <v-flex style="text-align: left">
              <textarea-form
                :rows="2"
                :model="form.topicNews"
                @update-data="updateData('topicNews', $event)"
              ></textarea-form>
            </v-flex>
          </v-layout>

          <!-- blog 2 -->
          <v-layout>
            <v-flex style="text-align: left;font-weight: bold">
              <span>Caption</span>
            </v-flex>
          </v-layout>
          <v-layout mt-2>
            <v-flex style="text-align: left">
              <textarea-form
                :rows="3"
                :model="form.caption"
                @update-data="updateData('caption', $event)"
              ></textarea-form>
            </v-flex>
          </v-layout>

          <!-- blog 3 -->
          <v-layout>
            <v-flex style="text-align: left;font-weight: bold">
              <span
                >รายละเอียด
                <span style="font-weight: normal">(ข้อมูลข่าวสาร)</span></span
              >
            </v-flex>
          </v-layout>
          <v-layout mt-2 mb-8>
            <v-flex style="text-align: left">
              <!--<vue-editor-->
              <!--style="background-color: #FBF6F3;"-->
              <!--id="editor"-->
              <!--useCustomImageHandler-->
              <!--@image-added="handleImageAdded"-->
              <!--v-model="form.detail"-->
              <!--&gt; </vue-editor>-->

              <editor
                v-model="form.detail"
                api-key="fppvvlbcx1bpoj5azejbsnnlyb06sxlwyaa1rlf1w03c3wgv"
                :init="{
                  height: 500,
                  menubar: true,
                  plugins:
                    'table wordcount | image | searchreplace | fullscreen | lists | visualblocks | media | link',
                  toolbar:
                    'undo redo | link image media | visualblocks | fullscreen | styleselect | forecolor backcolor bold italic underline | align | numlist bullist',
                  image_title: true,
                  automatic_uploads: true,
                  file_picker_types: 'image',
                  file_picker_callback: function(cb, value, meta) {
                    uploadImageMCE(cb, value, meta);
                  },
                }"
              />
            </v-flex>
          </v-layout>

          <!-- blog 4 -->
          <v-layout>
            <v-flex style="text-align: left;font-weight: bold">
              <span>รายละเอียดย่อย</span>
              <span style="font-weight: normal">(เช่น กำหนดการ สถานที่)</span>
            </v-flex>
          </v-layout>
          <v-layout mt-2>
            <v-flex style="text-align: left">
              <textarea-form
                :rows="3"
                :model="form.subDetails"
                @update-data="updateData('subDetails', $event)"
              ></textarea-form>
            </v-flex>
          </v-layout>

          <!-- blog 5 -->
          <v-layout>
            <v-flex mr-12 xs6 style="text-align: left;font-weight: bold">
              <span
                >รูปภาพหน้าปก
                <span style="color: red"
                  >*(ขนาดของรูปภาพที่เหมาะสมคือ 520*300 px)</span
                >
              </span>
            </v-flex>
            <v-flex xs4 style="text-align: left;font-weight: bold">
              <span>วันที่จัดกิจกรรม / วันที่ประกาศ</span>
            </v-flex>
          </v-layout>
          <v-layout mt-2>
            <v-flex mr-12 xs6 style="text-align: left;font-weight: bold">
              <v-file-input
                v-model="form.image"
                label="File input"
                outlined
                dense
                color="#3E7662"
                clearable
                background-color="#FBF6F3"
                append-icon="image_search"
              ></v-file-input>
            </v-flex>
            <v-flex xs4 style="text-align: left;font-weight: bold">
              <DateInputForm
                :model="dateChage"
                @update-data="updateDate('date', $event)"
              ></DateInputForm>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
      <v-divider
        style="background-color: #544A44;border-width: 2px"
      ></v-divider>
    </v-card>

    <!-- Button -->
    <v-layout mt-12>
      <v-flex mr-8 d-flex justify-end>
        <v-btn color="#FFFFFF" @click.native="$router.go(-1)">
          <span style="color: #3E7662;font-weight: bold">ย้อนกลับ</span>
        </v-btn>
      </v-flex>
      <v-flex mr-12 shrink d-flex justify-end>
        <v-btn color="#3E7662" dark
          ><span style="font-weight: bold" @click="save"
            >ยืนยันการบันทึก</span
          ></v-btn
        >
      </v-flex>
    </v-layout>

    <loading
      color="#527281"
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="fullPage"
    ></loading>
  </v-content>
</template>

<script>
import TextareaForm from "../../components/input/TextareaForm";
import DateInputForm from "../../components/input/DateInputForm";
// import { VueEditor } from "vue2-editor";
import Swal from "sweetalert2";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import axios from "axios";
import Editor from "@tinymce/tinymce-vue";
// import { domain } from "../../services/Constants";

export default {
  name: "CreateNews",
  components: {
    TextareaForm,
    // VueEditor,
    DateInputForm,
    Loading,
    Editor,
  },
  data: () => ({
    isLoading: false,
    fullPage: true,
    form: {
      topicNews: "",
      caption: "",
      detail: "",
      subDetails: "",
      date: "",
      image: null,
    },
    dateChage: "",
    htmlForEditor: "",
  }),
  methods: {
    updateData(name, val) {
      this.form[name] = val;
    },
    updateDate(name, val) {
      if (name === "date") {
        this.form[name] = val.date;
        this.dateChage = val.changeDate;
      }
    },
    save() {
      this.isLoading = true;
      this.$store
        .dispatch("News/save", this.form)
        .then((res) => {
          this.isLoading = false;
          Swal.fire({
            title: "เพิ่มข้อมูลสำเร็จ",
            icon: "success",
            confirmButtonColor: "#3E7662",
          }).then(() => {
            this.$router.push("/all-news");
          });
        })
        .catch((e) => {
          this.isLoading = false;
          if (e.response.data.errors) {
            for (var k in e.response.data.errors) {
              Swal.fire({
                title: "เกิดข้อผิดพลาด",
                text: e.response.data.errors[k][0],
                icon: "warning",
                confirmButtonColor: "#3E7662",
              }).then(() => {
                this.$vuetify.goTo(`#${k}`);
              });
            }
          }
          // this.isLoading = false;
        });
    },
    handleImageAdded: function(file, Editor, cursorLocation, resetUploader) {
      this.isLoading = true;
      this.$store
        .dispatch("News/uploadImage", file)
        .then((result) => {
          this.isLoading = false;
          let url = result.filePath; // Get url from response
          Editor.insertEmbed(cursorLocation, "image", url);
          resetUploader();
        })
        .catch((err) => {
          this.isLoading = false;
          console.log(err);
        });
    },
    uploadImageMCE(cb, value, meta) {
      var input = document.createElement("input");
      input.setAttribute("type", "file");
      input.setAttribute("accept", "image/*");
      let _this = this;

      input.onchange = function() {
        var file = this.files[0];
        var reader = new FileReader();
        reader.onload = function() {
          console.log("onload");
          var id = "blobid" + new Date().getTime();
          var blobCache = tinymce.activeEditor.editorUpload.blobCache;
          var base64 = reader.result.split(",")[1];
          var blobInfo = blobCache.create(id, file, base64);
          blobCache.add(blobInfo);

          var fd = new FormData();
          fd.append("image", file);
          fd.append("file_name", file.name);

          console.log("before dispatch");
          _this.$store.dispatch("News/uploadImage", file).then((data) => {
            console.log("after", data);
            cb(data.filePath, { title: file.name });
          });
        };
        reader.readAsDataURL(file);
      };
      input.click();
    },
  },
};
</script>

<style scoped>
.upload-image {
  padding: 50px 50px 50px 50px;
  font-weight: bold;
  border-style: dashed;
  border-width: 2px;
  border-color: #000;
}
</style>
